import { z } from 'zod';

const PHONE_REGEX = /^(?:\+1[- .]?)?\(?(\d{3})\)?[- .]?(\d{3})[- .]?(\d{4})$/;
const EMAIL_REGEX =
  /([a-zA-Z0-9!?#$%^&+=._-](?!.*\.\.))+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})/;

const EMAIL_OR_PHONE_REGEX = new RegExp(
  `^(?:${PHONE_REGEX.source}|${EMAIL_REGEX.source})$`,
);

const emailOrPhoneError = 'Enter a valid email or phone number';
const requiredError = 'Required';

export const loginSchema = z.object({
  emailOrPhone: z
    .string({ error: requiredError })
    .min(1, { message: requiredError })
    .refine((val) => EMAIL_OR_PHONE_REGEX.test(val), {
      message: emailOrPhoneError,
    }),
  password: z.string({ error: requiredError }).min(1, { error: requiredError }),
});
